import { render, staticRenderFns } from "./VsScenarioSettings.vue?vue&type=template&id=02b8fa87&scoped=true&"
import script from "./VsScenarioSettings.vue?vue&type=script&lang=js&"
export * from "./VsScenarioSettings.vue?vue&type=script&lang=js&"
import style0 from "./VsScenarioSettings.vue?vue&type=style&index=0&id=02b8fa87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b8fa87",
  null
  
)

export default component.exports